var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FF5958",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.286,
    clipPath: "url(#logout-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.214 16.5v2.571a1.286 1.286 0 0 1-1.286 1.286h-9a1.286 1.286 0 0 1-1.285-1.286V4.93a1.286 1.286 0 0 1 1.286-1.286h9a1.286 1.286 0 0 1 1.285 1.286V7.5M11.357 12h9M17.786 9.429 20.357 12l-2.571 2.571"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logout-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h18v18H3z"
  })))));
};
export default SvgLogoutIcon;